import client from './http';

export const STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

const ServerAuthenticationErrorTypes = {
  CODE_EXPIRED: 'CODE_EXPIRED',
  INVALID_CODE: 'INVALID_CODE',
};

export const ClientAuthenticationErrorTypes = {
  COOKIES_DISABLED: 'COOKIES_DISABLED',
  CODE_EXPIRED: 'CODE_EXPIRED',
  INVALID_CODE: 'INVALID_CODE',
  REQUIRED_FIELD_MISSING: 'REQUIRED_FIELD_MISSING',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
};

function _isRequiredFieldMissing(err) {
  // In case of validation error in olaf - the data of the error response will contain validation property
  return err.response.data?.validation;
}

function _mapAuthenticateErrorCode(err) {
  if (err.response && err.response.status === 400) {
    if (_isRequiredFieldMissing(err)) {
      return ClientAuthenticationErrorTypes.REQUIRED_FIELD_MISSING;
    }
    if (err.response.data === ServerAuthenticationErrorTypes.CODE_EXPIRED) {
      return ClientAuthenticationErrorTypes.CODE_EXPIRED;
    }
    if (err.response.data === ServerAuthenticationErrorTypes.INVALID_CODE) {
      return ClientAuthenticationErrorTypes.INVALID_CODE;
    }
  }
  if (err.response && err.response.status === 409) {
    return ClientAuthenticationErrorTypes.COOKIES_DISABLED;
  }
  return ClientAuthenticationErrorTypes.UNKNOWN_ERROR;
}

export async function generateCode({ phoneNumber, force, sendPlatform }) {
  try {
    const data = await client.post('/api/no-auth/login/generate-code', { phoneNumber, force, sendPlatform });
    return { status: STATUS.SUCCESS, data };
  } catch (err) {
    return { status: STATUS.FAILURE };
  }
}

export async function authenticate({ phoneNumber, code }) {
  try {
    const result = await client.post('/api/no-auth/login/authenticate', { phoneNumber, code });
    return { status: STATUS.SUCCESS, data: result.data };
  } catch (err) {
    return { status: STATUS.FAILURE, errorType: _mapAuthenticateErrorCode(err) };
  }
}

export async function isLoggedIn() {
  const response = await client.get('/api/saving/logged-in/', {
    validateStatus: status => status === 200 || status === 403,
  });
  return response.status === 200;
}
